var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 16.6667C2.87533 16.6667 2.48296 16.5035 2.15658 16.1771C1.83019 15.8507 1.66699 15.4583 1.66699 15V4.99999C1.66699 4.54166 1.83019 4.1493 2.15658 3.82291C2.48296 3.49652 2.87533 3.33333 3.33366 3.33333H16.667C17.1253 3.33333 17.5177 3.49652 17.8441 3.82291C18.1705 4.1493 18.3337 4.54166 18.3337 4.99999V15C18.3337 15.4583 18.1705 15.8507 17.8441 16.1771C17.5177 16.5035 17.1253 16.6667 16.667 16.6667H3.33366ZM10.0003 10.8333L3.33366 6.66666V15H16.667V6.66666L10.0003 10.8333ZM10.0003 9.16666L16.667 4.99999H3.33366L10.0003 9.16666ZM3.33366 6.66666V4.99999V15V6.66666Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.2a582d9877676ff493df26728389c782.svg";
export { ForwardRef as ReactComponent };